import { Flex } from "@chakra-ui/react";

import FormButton from "@/components/ui/auth/FormButton";

const HideButtons = ({ handlers }) => {
  return (
    <Flex align={"center"} justify={"center"} columnGap={"8px"}>
      <FormButton
        {...{
          title: "Show all",
          button: {
            bg: "transparent",
            borderColor: "mainBlue",
            borderWidth: "1px",
            color: "mainBlue",
            maxW: "84px",
            h: "30px",
            p: "0",
            fontSize: "10px",
            fontWeight: "700",
            _hover: { bg: "lightBlue2" },
            onClick: handlers.showAll,
          },
        }}
      />
      <FormButton
        {...{
          title: "Hide all",
          button: {
            bg: "transparent",
            borderColor: "mainBlue",
            borderWidth: "1px",
            color: "mainBlue",
            maxW: "84px",
            h: "30px",
            p: "0",
            fontSize: "10px",
            fontWeight: "700",
            _hover: { bg: "lightBlue2" },
            onClick: handlers.hideAll,
          },
        }}
      />
    </Flex>
  );
};

export default HideButtons;
